import styled from 'styled-components';
import ds from 'designsystem';

const LinksWrapper = styled.div`
  padding-top: ${ds.get('metrics.s')};
  display: flex;
  flex-wrap: wrap;
`;

export default LinksWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/CallUs/ContactPerson/LinksWrapper.jsx